<template lang="pug">
#card_Lamination
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_card_Lamination.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_card_Lamination_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 卡片貼合
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 本製品可經印刷、貼合、衝卡、打碼、分卡質檢等工序製成各種卡片。
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative.active PVC
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品印刷性佳、耐曲折、貼合性優良、堅韌性高，可經印刷、貼合等加工，製成信用卡、識別卡、掛號卡等卡片。
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span PVC 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_2
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC卡片貼合-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC硬質膠布印刷性佳、耐曲折、貼合性優良、堅韌性高，可經印刷、貼合等加工，製成信用卡、識別卡、掛號卡等卡片。有信用卡面料用、信用卡中料用等。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、PVC、信用卡、面料、中料、卡片、貼合。' },
            { name: 'og:title', content: 'PVC卡片貼合-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'PVC硬質膠布印刷性佳、耐曲折、貼合性優良、堅韌性高，可經印刷、貼合等加工，製成信用卡、識別卡、掛號卡等卡片。有信用卡面料用、信用卡中料用等。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: '卡片貼合',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/card_Lamination_img_01.jpg',
            img_alt: '南亞硬質PVC膠布印刷性佳、耐曲折、貼合性優良、堅韌性高，可製成信用卡、識別卡、掛號卡等卡片。' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/card_Lamination_img_02.jpg',
            img_alt: '南亞硬質PVC膠布印刷性佳、耐曲折、貼合性優良、堅韌性高，可製成信用卡、識別卡、掛號卡等卡片。' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: '印刷性佳。' },
          { message: '耐曲折、貼合性優良。' },
          { message: '堅韌性高。' },
          { message: '符合歐盟REACH、ROHS規範要求。' }
        ],
        p_use: [
          { message: '可客製化項目：耐寒、耐溫、耐候及耐燃等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、JIS-K6734及ASTM D-1525等。' }
        ],
        p_specification: [
          { 
            id: '1',
            name: '信用卡面料VLLA',
            feature: '特色: 貼合性及展平性佳',
            outward: '外觀: 半透明、有色、霧面',
            thickness: '參考厚度<sub>(mm)</sub>：0.10 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.33±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/><span class="pl-5">MD>90/CD>35</span>',
            heating: '加熱收縮<sub>(%,100°CX10分)</sub>：<br/><span class="pl-5">MD＞-22/CD<10</span>',
            vcm: 'VICAT針入度<sub>(℃)</sub>：未管制' },
          { 
            id: '2',
            name: '信用卡中料VPPT',
            feature: '特色: 印刷性、貼合性及堅韌性佳',
            outward: '外觀: 有色、霧面',
            thickness: '參考厚度<sub>(mm)</sub> ：0.25',
            proportion: '比重<sub>(g/cm3)</sub> ：1.40±0.05',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>400/CD>380</span>',
            elongation: '伸長率<sub>(%)</sub> ：<br/><span class="pl-5">MD>100/CD>70</span>',
            heating: '加熱收縮<sub>(%,100°CX10分)</sub>：<br/><span class="pl-5">MD＞-12/CD<5</span>',
            vcm: 'VICAT針入度<sub>(℃)</sub>：80±2' }
        ],
        swiperOption_pvc: {
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'食藥醫療',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'抗靜電包裝',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'建材裝潢',
            text:'在連續基材上，經過印刷、塗佈、貼合或壓製等工藝而製成的產品。 複合塑膠建材裝璜產品是由多層結構熱壓而成..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'5',
            name:'事務文具',
            text:'本製品可經印刷、貼合、沖裁或熔著等工序製成各種事務文具用產品。',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'水處理',
            text:'本製品之加工方式有軋壓及成型兩種。客戶若使用成型方式加工，則須特別管制成型性。',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green APET',
            text:'PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET膠布',
            text:'C-PET膠布需經由壓空成型機模具加熱成型使其結晶，成型品可耐高溫。',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#card_Lamination
  #specification
    background-image: url(../assets/bg/bg_card_Lamination.jpg)


</style>
